/**
 * PrivacyPolicyPage — renders the counsel-drafted multi-jurisdiction
 * Privacy Policy (UAE PDPL · India DPDPA · EU/UK GDPR · US state laws).
 *
 * Source: legal/Xpert_Privacy_Policy.docx, extracted by
 * bin/extract_legal_docs.py.
 */
import LegalDocViewer from "@/components/LegalDocViewer";
import privacyContent from "@/legal-rendered/privacy_policy";

export default function PrivacyPolicyPage() {
  return (
    <LegalDocViewer
      title="Privacy Policy"
      subtitle="Multi-jurisdiction notice (UAE · India · EU/UK · United States)"
      policyId="privacy_policy"
      policyVersion="1.1.0"
      content={privacyContent}
    />
  );
}
